import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Plus, X, Receipt, Upload } from 'lucide-react';

interface BoletoFABProps {
    onAdd: () => void;
}

const BoletoFAB: React.FC<BoletoFABProps> = ({ onAdd }) => {
    const [isOpen, setIsOpen] = useState(false);

    return createPortal(
        <div className="fixed bottom-8 right-8 z-[100] flex flex-col items-end gap-3">
            {isOpen && (
                <div className="flex flex-col items-end gap-3 mb-2 animate-fade-in-up">
                    <button
                        onClick={() => {
                            onAdd();
                            setIsOpen(false);
                        }}
                        className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 font-semibold rounded-lg shadow-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all border border-gray-100 dark:border-gray-700"
                    >
                        <span className="text-sm">Adicionar informações</span>
                        <div className="w-8 h-8 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center text-primary dark:text-primary-light">
                            <Receipt size={16} />
                        </div>
                    </button>

                    <button
                        disabled
                        className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-gray-800 text-gray-400 dark:text-gray-500 font-semibold rounded-lg shadow-lg border border-gray-100 dark:border-gray-700 cursor-not-allowed"
                    >
                        <span className="text-sm">Upload do PDF (Em breve)</span>
                        <div className="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-400 dark:text-gray-500">
                            <Upload size={16} />
                        </div>
                    </button>
                </div>
            )}

            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`group flex items-center gap-2 pl-4 pr-2 py-2 rounded-full shadow-xl transition-all duration-300 ${isOpen ? 'bg-gray-800 dark:bg-gray-700 text-white' : 'bg-primary text-white hover:bg-primary-dark'
                    }`}
            >
                <span className="font-bold text-sm">Adicionar novo boleto</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-transform duration-300 ${isOpen ? 'bg-gray-700 dark:bg-gray-600 rotate-45' : 'bg-white/20'
                    }`}>
                    <Plus size={20} />
                </div>
            </button>
        </div>,
        document.body
    );
};

export default BoletoFAB;
